import React from "react";

export default function ApprovalLine_print({ lines = [] }) {
  if (!Array.isArray(lines) || lines.length === 0) return null;

  const approvals = lines
    .filter((l) => l.order !== 0)
    .sort((a, b) => (a.order ?? 0) - (b.order ?? 0));

  if (approvals.length === 0) return null;

  return (
    <section
      className="mt-4 mb-4 print:break-inside-avoid text-[12px] text-center"
      style={{ position: "relative", overflow: "visible" }}
    >
      <div className="flex justify-center" style={{ overflow: "visible" }}>
        <table
          className="border border-black text-center relative"
          style={{
            tableLayout: "fixed",
            borderCollapse: "collapse",
            overflow: "visible",
            position: "relative",
          }}
        >
          <thead>
            <tr className="bg-gray-50">
              {approvals.map((line, idx) => (
                <th
                  key={idx}
                  className="border border-black w-[55px] px-1 py-1 align-middle"
                >
                  <div className="text-[10px] leading-tight truncate">
                    {line.approver_name || "미상"}
                  </div>
                  <div className="text-[9px] text-gray-500 leading-tight truncate">
                    {line.approver_position || "-"}
                  </div>
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            <tr>
              {approvals.map((line, idx) => {
                const state = line.is_approved;
                const sign = line.sign_file;
                const symbol =
                  state === "approved"
                    ? "✓"
                    : state === "rejected"
                    ? "✗"
                    : "미결";
                const color =
                  state === "approved"
                    ? "text-green-600"
                    : state === "rejected"
                    ? "text-red-600"
                    : "text-gray-400";

                return (
                  <td
                    key={idx}
                    className="border border-black relative w-[55px] text-center"
                    style={{
                      height: "40px",
                      overflow: "visible",
                      position: "relative",
                    }}
                  >
                    {state === "approved" && sign ? (
                      <>
                        {/* 싸인을 테이블 기준으로 절대 위치 */}
                        <img
                          src={sign}
                          alt="서명"
                          style={{
                            position: "absolute",
                            top: "-61px", // ✅ 위로 띄움
                            left: "-1%",
                            height: "160px",
                            width: "200px",
                            objectFit: "contain",
                            zIndex: 20,
                            pointerEvents: "none",
                          }}
                        />
                        <div className="invisible">✓</div>
                      </>
                    ) : (
                      <div className={`text-lg ${color}`}>{symbol}</div>
                    )}
                  </td>
                );
              })}
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  );
}
